import { Column } from '../../../../model/table';
import { ApplicationField, LogsDto, TimestampField } from '../../../../dtos/logs.dto';
import { ActionCellTrafficLog, IpWithTooltipCell, TooltipCell } from './special-cells';

export const trafficColumns: Column<LogsDto>[] = [
    {
        accessor: TimestampField,
        header: TimestampField,
        width: 200,
    },
    {
        accessor: 'IP Protocol',
        header: 'IP Protocol',
        width: 150,
    },
    {
        accessor: 'Direction',
        header: 'Direction',
        width: 110,
    },
    {
        accessor: 'Source IP',
        header: 'Source IP',
        width: 350,
        getDisplayElement: IpWithTooltipCell
    },
    {
        accessor: 'Source Country',
        header: 'Source Country',
        width: 200,
    },
    {
        accessor: 'Destination IP',
        header: 'Destination IP',
        width: 350,
        getDisplayElement: IpWithTooltipCell
    },
    {
        accessor: 'Destination Country',
        header: 'Destination Country',
        width: 200,
    },
    {
        accessor: 'To Port',
        header: 'To Port',
        width: 150,
    },
    {
        accessor: ApplicationField,
        header: ApplicationField,
        width: 250,
        getDisplayElement: TooltipCell
    },
    {
        accessor: 'Child App',
        header: 'Child App',
        width: 200,
    },
    {
        accessor: 'Rule',
        header: 'Rule',
        width: 200,
        getDisplayElement: TooltipCell
    },
    {
        accessor: 'Action',
        header: 'Action',
        getDisplayElement: ActionCellTrafficLog,
        width: 150,
    },
    {
        accessor: 'Session Duration',
        header: 'Session Duration',
        width: 200,
    },
    {
        accessor: 'Bytes Sent',
        header: 'Bytes Sent',
        width: 200,
    },
    {
        accessor: 'Bytes Received',
        header: 'Bytes Received',
        width: 200,
    },
    {
        accessor: 'Session End Reason',
        header: 'Session End Reason',
        width: 200,
    }
];
